import { useMutation } from '@tanstack/react-query'
import { httpClient } from '../../../shared/api/httpClient'

async function fetchSeedToken(params) {
  const response = await httpClient.get('/robots/seed', { params })
  return response.data
}

export function useSeedTokenQuery() {
  const mutation = useMutation({
    mutationFn: ({ login, tribunal }) => fetchSeedToken({ login, tribunal }),
  })

  return {
    result: mutation.data ?? null,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    search: mutation.mutate,
    reset: mutation.reset,
  }
}

export default useSeedTokenQuery
